import { tableCustom } from '@core/containers/table-custom';
import { ILSCatalogTable } from '../../containers/table-container';
import { IPropsILSCatalogTable } from '@modules/catalog/types/components';
import { FC } from 'react';
import { CatalogDictionary, Dictionary } from '@common/types';
import { TRIP_TEMPLATE_TABLE_CONFIG, tripTemplates2table } from '@common/models/trip-template';

export const ILSCatalogTripTemplate: FC<IPropsILSCatalogTable> = tableCustom(
  (props) => {
    return <ILSCatalogTable {...props} dictionary={Dictionary.TripTemplate} dataDecorator={tripTemplates2table} />;
  },
  TRIP_TEMPLATE_TABLE_CONFIG,
  CatalogDictionary.TripTemplate,
  true
);
